<template>
  <section>
    <h1 class="title">{{name}}</h1>
    <p>The benefits of an online personal trainer vastly outweigh the disadvantages.</p>
    <p>Rather than being forced to fit your routine around when a trainer is available, an online trainer can work around you. Apart from the initial setup and regular check-ins you’ll be able to spend your time training as and when is easiest.</p>
    <p>Simply put: My online clients get SO much more from me thanan in-person clientele ever could.</p>
    <p>At the same time, you still get the benefit of a qualified personal trainer to keep you on track, motivate you when you’re really not feeling up to it, and direct your exercise and nutrition routine so you can achieve your fitness goals.</p>
    <p>With upsides like the cost-effectiveness and real, trackable results, there’s no reason why you shouldn’t give it a try.</p>
    <p>The 6 main benefits of online personal training are:</p>
    <ul>
      <h3 class="title">Professional Advice</h3>
      <li>        
        <p>An online trainer will work with you to develop a program perfectly tailored to you and what you’re looking to achieve.</p>
      </li>
      <h3 class="title">Flexibility</h3>
      <li>        
        <p>The great thing about personal training online is that it’s completely flexible around you. </p>
      </li>
      <h3 class="title">Easy Communication</h3>
      <li>        
        <p>The digital world works out great for online training. Thanks to Skype, Facebook, WhatsApp and plenty others, it’s incredibly easy for you and your online trainer to keep in touch, even if you don’t meet up face-to-face. You’ll be able to access your workout routines on your phone, tablet, laptop or desktop whether at home or out and about.</p>
      </li>
      <h3 class="title">Get Attention and Motivation</h3>
      <li>        
        <p>Some people assume that because you’re not in the same location as your online trainer, you’ll feel demotivated by online training. But that’s simply not the case.</p>
        <p>It’s true that you need a bit of personal drive to get the most from any training program. However, it is  our job to stay in touch and make sure you don’t let yourself down. That might be a quick text or an hour-long Skype session, whatever it takes to keep you on track.</p>
      </li>
      <h3 class="title">More Affordable</h3>
      <li>        
        <p>If your budget is tight or it is just convenient, working online with an online trainer costs less than it would in person. That’s because they don’t have to give up as much of their time supervising your training sessions.</p>
        <p>Apart from that you’ll get exactly the same service as any other customer, an initial consultation, guidance on how to do exercises properly, advice on how to prepare your meals, regular check-ins and plenty more. </p>
      </li>
      <h3 class="title">The Same Results</h3>
      <li>        
        <p>If you’re dedicated there’s no reason why you shouldn’t get the same results through online training.</p>
        <p>Modern apps and tools mean us trainers can keep close tabs on your progress, whether we live ten miles away or in a different country. With video calling we can show you exactly how to do specific exercises and you can show us that your technique is right.</p>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
      name: "ONLINE COACHING"
    };
  }
};
</script>

<style scoped src="./OnlineCoaching.css"></style>
